/* eslint-disable react-hooks/exhaustive-deps */
import { isEmpty, isFunction } from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Filters from "../../../components/Filters";
import PageHeader from "../../../components/PageHeader";
import { ControlTable } from "../../../components/Table";
import { COMMUNITY_BOARD_SEARCH_OPTIONS } from "../../../constants/COMMUNITY";
import useForm from "../../../hooks/useForm";
import { getParams } from "../../../utils/params";
// import systemAlert from "../../../utils/systemAlert";
import DetailTaxConsultingPost from "./DetailTaxConsultingPost";
import CommentIcon from "../../../assets/images/icon/comment-icon.svg";
import Icon from "../../../components/Icon";
import { getTaxConsultingCategories, getTaxConsultingBoards, getTaxConsultingBoardPosts, getTaxConsultingContent } from "../../../apis/tax-portal/tax-consulting";
import { dps } from "../../../utils/lodashExtend";
import Loading from "../../../components/Loading";
import NoData from "../../../components/NoData/NoData";
import successChecked from "../../../assets/images/icon/success-checked.svg";
import DetailTaxConsulting from "./DetailTaxConsulting";
import { useSelector } from "react-redux";
import { isBoardRole, findCategoryManager } from "../../../utils/tax-consulting";
import queryString from "query-string";
import EditButton from "../../../assets/images/icon/edit-btn.svg";
import { preventEvent } from "../../../utils/element";
import Button from "../../../components/Button";
import { isAdmin } from "../../../utils/auth";
import DataComponent from "../../../components/DataComponent";
import TaxConsultingCollaborationCompanies from "./TaxConsultingCollaborationCompanies";
import { profilePreview } from "../../../utils/externalProfile";
import systemAlert from "../../../utils/systemAlert";

const defaultValue = {
  page: 0,
  limit: 10,
  searchType: "title",
};

const TaxConsultingBoard = ({ categoryIdx, boardIdx, ...props }) => {
  const history = useHistory();

  const { employee } = useSelector((store) => ({
    employee: store.Profile.employee,
  }));


  const [mode, setMode] = useState('create');

  const [categoryInfo, setCategoryInfo] = useState([]);
  const [parentCategoryInfo, setParentCategoryInfo] = useState([]);
  const [boards, setBoards] = useState([]);
  const [currentBoard, setCurrentBoard] = useState({});
  const [selectedBoard, setSelectedBoard] = useState(null);
  const [myManager, setMyManager] = useState(null);
  const [boardOpen, setBoardOpen] = useState(false);

  const [isCollaboration, setIsCollaboration] = useState(false);

  const _setActiveTab = (value) => {
    history.push(`/tax-portal/tax-consulting/?categoryIdx=${categoryIdx}&boardIdx=${value}`);
  };

  const [notices, setNotices] = useState([]);
  const [fields, setFields] = useState([]);
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedCommunityPost, setSelectedPost] = useState(null);

  const [filters] = useState([
    {
      title: "분류",
      type: "select",
      key: "searchType",
      options: {
        list: COMMUNITY_BOARD_SEARCH_OPTIONS,
      },
    },
    {
      title: "키워드 검색",
      type: "input",
      key: "searchText",
      placeholder: "검색어 입력",
    },
  ]);

  const [headerButtons, setHeaderButtons] = useState([]);


  const {
    form,
    setSubmit,
    handleOnChange,
    handleSubmit,
    // LIST 용
    reSubmit,
    filterSubmit,
    list, setList,
    isLoading, setIsLoading,
    total, setTotal,
    page, setPage,
    limit, setLimit,
  } = useForm(defaultValue);

  const init = async () => {
    setIsLoading(true);

    setCategoryInfo(undefined);
    setParentCategoryInfo(undefined);
    setBoards(undefined);
    setCurrentBoard(undefined);

    const { data } = await getTaxConsultingCategories();
    const { data: _boards } = await getTaxConsultingBoards(Number(categoryIdx));
    const query = queryString.parse(history.location.search);
    if (isEmpty(query.boardIdx) && !isEmpty(_boards)) {
      history.push(`/tax-portal/tax-consulting/?categoryIdx=${categoryIdx}&boardIdx=${_boards[0].idx}`);
      return;
    }
    const currentCategory = dps(data, Number(categoryIdx), 'childCategories');
    const parentCategory = dps(data, Number(currentCategory.parentCategoryIdx), 'childCategories');

    setCategoryInfo(currentCategory);
    setParentCategoryInfo(parentCategory);
    setBoards(_boards.map((data) => {
      return { ...data, label: data.title, value: data.idx, action: _setActiveTab, };
    }));
    if (!isEmpty(_boards)) {
      if (!boardIdx)
        setCurrentBoard(_boards[0]);
      else
        setCurrentBoard(_boards.find((item) =>
          item.idx === Number(boardIdx)
        ));
    }
    setSubmit(submit);
  };

  useEffect(() => {
    setHeaderButtons([
      {
        isHide: () => !(myManager?.isWrite || myManager?.isAdmin || isAdmin()),
        label: `${currentBoard?.title} 관리`,
        color: "gray-line",
        action: () => {
          setMode("create");
          setBoardOpen(true);
          setSelectedBoard(currentBoard);
        },
      },
      {
        isHide: () => !(myManager?.isWrite || myManager?.isAdmin || isAdmin()),
        label: `게시판 생성`,
        action: () => {
          setBoardOpen(true);
        },
      },
      {
        isHide: () => !categoryInfo?.isCollaborationAvailability && !(!!myManager && categoryInfo?.isCollaboration),
        label: `협업 요청하기`,
        action: () => {
          setIsCollaboration(true);
        },
      },
    ]);

    if (!isEmpty(currentBoard) && employee) {
      submit(defaultValue);
      const _fields = [
        {
          key: 'count',
          width: '100px'
        },
        {
          title: "제목",
          className: 'text-align-left',
          key: "title",
          onValue: (value) => {
            return value === 'null' || isEmpty(value) ? <span className="color-red-80">삭제된 게시글 입니다.</span> : value;
          }
        },
        { title: "작성일시", key: "createdTime", type: 'datetime' },
        {
          title: "작성자",
          key: "employee",
          onValue: (v) => (
            <div onClick={() => {
              profilePreview(v.idx);
            }}>
              {!isEmpty(v.externalProfile)
                ? `${v.externalProfile?.companyName ? `${v.externalProfile?.companyName}-` : ""}${v.externalProfile?.name}`
                : `${v?.company?.name ? `${v?.company?.name}-` : ""}${v.name}`}
            </div>
          )
        },
        {
          title: '',
          key: 'comments',
          onValue: (value) => {
            return (
              !isEmpty(value) ? (
                <>
                  <Icon src={CommentIcon} />
                  <span className="ml-4 font-bold">{value.count}</span>
                </>
              ) : (<></>)
            );
          }
        },
        {
          type: "",
          title: "",

          onValue: (_v, _f, d) => {
            const roleCheck = isAdmin() ||
              (d.writerEmployeeIdx === employee.idx && isBoardRole(currentBoard));
            return (
              <>
                {roleCheck ? (
                  <Button
                    color="text"
                    style={{
                      padding: "6px 5px"
                    }}
                    onClick={((e) => {
                      preventEvent(e);
                      setDetailOpen(true);
                      setMode("modify");
                      setSelectedPost(d);
                    })}
                    label={
                      <>
                        <Icon src={EditButton} />
                      </>
                    }
                  />
                ) : (
                  <></>
                )}
              </>
            );
          }
        }
      ];

      setFields(_fields);
    }
  }, [employee, currentBoard, myManager, categoryInfo]);

  useEffect(() => {
    // 최초 세팅 
    if (categoryIdx) {
      init();
    }
  }, [categoryIdx, props.location.search]);

  const submit = ({ ..._params }) => {
    const query = queryString.parse(history.location.search);
    let boardIdx = query.boardIdx;
    if (+boardIdx > 0) {
      const params = getParams(_params);
      setTotal(0);
      setList([]);
      getTaxConsultingBoardPosts({
        ...params,
        search: {
          boardIdx,
          ...(params?.search ? params.search : {})
        },
        order: [{ createdTime: "desc" }]
      })
        .then((res) => {
          const { count, noticePosts, posts, comment, metadata } = res.data;
          setTotal(count);
          setList(posts.map((post, index) => ({
            ...post,
            count: count - metadata.offset - index,
            comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
          })));
          setNotices(noticePosts.map((post) => ({
            ...post,
            comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
          })));

        })
        .catch((err) => {
          console.error(err.response);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
  };


  const tableHeaderButtons = [
    {
      label: "글쓰기",
      isHide: () => {
        const isWrite = myManager?.isWrite;
        const myAccess = currentBoard?.accesses?.find(f => f.employeeIdx === employee?.idx);
        return !(myAccess?.role === "WRITE" || currentBoard?.role === "WRITE" || isWrite || isAdmin());
      },
      action: () => {
        setMode("create");
        setDetailOpen(true);
      },
    },
  ];
  const openDetail = (data, e) => {

    const { tagName } = e.target;
    if (tagName.toLowerCase() === "div") return;
    const myAccess = currentBoard?.accesses?.find(f => f.employeeIdx === employee.idx);

    const isReadList = (currentBoard.role !== "READ_LIST" && (myAccess && myAccess.role !== "READ_LIST")) || currentBoard.defaultRole === "READ";

    if (!data.deletedTime && (isAdmin() || myManager || isReadList)) {
      setMode("view");
      setDetailOpen(true);
      setSelectedPost(data);
    } else {
      systemAlert("게시물 열람 권한이 없습니다.");
    }
  };

  useEffect(() => {
    if (!isEmpty(currentBoard)) {
      const boardManager = selectedBoard?.managers?.find(f => f.employeeIdx === employee.idx);
      if (!isEmpty(boardManager)) {
        setMyManager(boardManager);
      } else {
        getTaxConsultingContent({})
          .then(res => {
            const categories = res.categories;
            const _myManager = findCategoryManager(categories, currentBoard.categoryIdx);
            setMyManager(_myManager);
          });
      }
    }
  }, [currentBoard]);

  return (
    <div>
      {
        categoryInfo ? <>
          <PageHeader
            title={`${parentCategoryInfo ? parentCategoryInfo.name + ' - ' : ''}  ${categoryInfo.name}`}
            // buttons={headerButtons}
            tabList={boards}
            activeTab={currentBoard?.idx}
          />
          <div className="tax-consulting-board-button-wrap">
            {!isEmpty(headerButtons) && (
              headerButtons.map((button, idx) => {
                return (isFunction(button.isHide) && button.isHide()) ||
                  (!isFunction(button.isHide) && button.isHide) ?
                  <React.Fragment key={`hide-button-${idx}`}></React.Fragment>
                  :
                  <DataComponent
                    key={idx}
                    field={{
                      type: 'button',
                      ...button,
                      className: "ml-8"
                    }}
                  />;
              })
            )}
          </div>
          {/* <TabList
            className="mb-10"
            tabList={boards || []}
            active={currentBoard?.idx}
          /> */}
          {currentBoard ? <div className="tax-consulting-board">
            <div className="tax-consulting-board-description-wrap">
              <div className="tax-consulting-board-description-text-wrap">
                <Icon src={successChecked} />
                <span className="tax-consulting-board-description-text">
                  {
                    currentBoard.description ?
                      currentBoard.description :
                      `${parentCategoryInfo.name}- ${categoryInfo.name}의 ${currentBoard.title}입니다.`
                  }
                </span>
              </div>
            </div>
            <Filters
              isLoading={isLoading}
              filters={filters}
              submit={filterSubmit}
              form={form}
              onChange={handleOnChange}
            />
            <ControlTable
              fields={fields}
              list={list}
              isLoading={isLoading}
              total={total}
              page={page}
              setPage={setPage}
              notices={notices}
              limit={limit}
              setLimit={setLimit}
              onSelect={openDetail}
              submit={handleSubmit}
              buttons={tableHeaderButtons}
            />
            <DetailTaxConsultingPost
              currentBoard={currentBoard}
              post={selectedCommunityPost}
              orgMode={mode}
              setPost={setSelectedPost}
              open={detailOpen}
              setOpen={setDetailOpen}
              submit={reSubmit}
            />


          </div> : <>
            <NoData text={"생성된 게시판이 없습니다."} />
          </>}
        </> : <Loading />
      }
      <DetailTaxConsulting
        open={boardOpen}
        setOpen={setBoardOpen}
        submit={init}
        employee={employee}
        categoryIdx={categoryIdx}
        category={categoryInfo}
        selectedBoard={selectedBoard}
        setSelectedBoard={setSelectedBoard}
      />

      <TaxConsultingCollaborationCompanies
        isOpen={isCollaboration}
        setIsOpen={setIsCollaboration}
        category={categoryInfo}
        parentCategory={parentCategoryInfo}
      />
    </div>
  );
};

export default TaxConsultingBoard;
